import { Controls } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';

const useStyles = createUseStyles((theme: ITheme) => ({
  container: {
    '--grid-count': '2',
    display: 'grid',
    gap: 16,
    gridTemplateColumns: 'repeat(var(--grid-count), 1fr)',
    marginTop: theme.spacings.s12,
  },
  singleInput: {
    '--grid-count': '1',
  },
  currentRatio: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    height: 40,
    padding: `${theme.spacings.s0} ${theme.spacings.s12}`,
    border: `1px solid ${Controls.border.default}`,
    borderRadius: theme.radiuses.r8,
  },
  inputSide: {
    marginBottom: 4,
    fontSize: 14,
    lineHeight: 1.4,
    color: '#545869',
  },
  disabledRatio: {
    opacity: 0.4,
  },
  ratioInput: {
    width: '99%',
    fontSize: 14,
    lineHeight: 1.25,
    color: theme.colors.texts.negative,
  },
  ratioTitle: {
    fontSize: 14,
    lineHeight: 1.25,
    color: '#9393ad',
    right: theme.spacings.s0,
  },
}));

export default useStyles;
